//
//
//
//
//
//
//
//
//
//
//

/**
 * Original Author: Josh Porter
 * Original Team: Unidrythons
 */
/**
 * The Badge component can wrap any type of content to highlight information to a user or to just draw attention to a specific element.
 */
export default {
  name: 'NsBadge',
  props: {
    /**
     * Applies specified color to the control - it can be the name of material color (for example `success` or `purple`) or css color (`#033` or `rgba(255, 0, 0, 0.5)`)
     * NOTE: at the moment we cannot use colors such as `primary` or `secondary` as these are globally assuming button styling.
     */
    color: {
      type: String,
      default: '#008AB0',
    },
    /**
     * Align the component towards the left
     */
    left: {
      type: Boolean,
      default: false,
    },
    /**
     * Align the component towards the bottom
     */
    bottom: {
      type: Boolean,
      default: false,
    },
    /**
     * Component will overlap the slotted content
     */
    overlap: {
      type: Boolean,
      default: false,
    },
  },
};
